import { type EntityEvent, EntityEventType, EntityType } from '@racemap/sdk/schema/entityEvents';

/**
 * Determines if an alert was generated by the frontend.
 *
 * This function checks if the alert is related to a STARTERS entity and
 * has an event type of either NO_MOVEMENT or AWAY_FROM_TRACK, which indicates
 * it was generated on the frontend rather than received from a backend service.
 *
 * @param {EntityEvent} alert - The alert entity event to check
 * @returns {boolean} True if the alert was generated by the frontend, false otherwise
 */
export const isFrontendGeneratedAlert = (alert: EntityEvent): boolean => {
  return (
    alert.entityType === EntityType.STARTERS &&
    (alert.eventType === EntityEventType.NO_MOVEMENT ||
      alert.eventType === EntityEventType.AWAY_FROM_TRACK)
  );
};
